import React from "react";
import handImage from "./images/hand.webp"; // Replace with your actual image path

const BackgroundRemoverp2: React.FC = () => {
    return (
        <div className="mx-auto font-poppins w-full px-8 max-w-5xl mt-10 text-left">
            <div className="flex flex-col md:flex-row items-center justify-center min-h-[700px]  gap-10 bg-white">
                {/* Text Section */}
                <div className="md:w-1/2 space-y-4">
                    <h2 className="text-3xl md:text-4xl text-left font-poppins font-bold text-[#242424]">
                        Create transparent cutout backgrounds for your photos.
                    </h2>
                    <p className="text-[#242424] text-sm md:text-lg text-left font-poppins">
                       This free background remover app allows you to highlight the subject of your photo and create a clear background, so you can place your new image into a variety of new designs and destinations. Place it on a colored backdrop or add a new background to put your subject in a completely new environment.
                    </p>
                </div>

                {/* Image Section */}
                <div className="md:w-1/2 relative">
                    <img src={handImage} alt="Background Removal Illustration" className="w-full max-w-sm mx-auto" />
                    {/* You can overlay abstract shapes using absolute divs or add SVGs here */}
                </div>
            </div>
        </div>
    );
};

export default BackgroundRemoverp2;
